import React from "react";

import ModalChart from "../../DevServices/ModalChart";
import Chart from "../../DevServices/Chart";


const SensorsTableDays = (props) => {
  const {selectedDev, modalChart, t_get_sensor_data_by_date, update_modal_chart} = props
  
  if (modalChart.sensor_data_for_modal?.sensors_card_data) {
    console.log(modalChart.sensor_data_for_modal?.sensors_card_data[0].data_for_graph)
  } else {
    //console.log('---------------------')
  }
  //if (requestData?.sensors_card_data?.sensor_data?.length === 0) return null
  if (!selectedDev.requestData.sensors_card_data?.length ) return null

  const sensorsArray = selectedDev.requestData?.sensors_card_data_xdays_back

  const suffArray = []

  

  //console.log(selectedDev.requestData.info)
  //console.log(selectedDev)


  

  return (
    <div className="container mt-5">
          
{/* 
          <table className="table table-striped">
          {theadContent(sensorsArray[0].data_xdays_back[0])}
              <tbody>
                {tbodyContent(sensorsArray[0].data_xdays_back)}
              </tbody>
          </table> */}

        {
         sensorsArray.map((s,i) => {
            //console.log(s.card_sensor_data)
            const suffArray = ['']; //first suffix '' for date value
            s.card_sensor_data.map(v => suffArray.push(v.card_suffix))
            //console.log(suffArray)
            return (
            <div className="container mt-5" key={'ta_' + i}>
                <h4>Sensor #{s.sensor_id}</h4>

                <table className="table table-striped" key={'tt_' + i}>
                {theadContent(s.data_xdays_back[0])}
                    <tbody>
                      {tbodyContent(s.data_xdays_back, s.dev_id, s.sensor_id, t_get_sensor_data_by_date, suffArray)}
                    </tbody>
                </table>
            </div>
            )
         })
        }

       {/* Modal Form */}
       {modalChart.sensor_data_for_modal?.sensors_card_data 
        && 
        <div>
            <ModalChart 
            title={"Title Hello"} 
            body={"Body Hello"}
            update_modal_chart = {update_modal_chart}
            isModal={modalChart.isModal}
            modalTitle = {modalChart.modalTitle}
            sensor_data_for_modal = {modalChart.sensor_data_for_modal?.sensors_card_data[0].data_for_graph}
            />
        </div>
        }

      </div>
  )
}

export default SensorsTableDays


const theadContent = (firstArrayElement) => {
/*     console.log(firstArrayElement)  dataArray.map((v,i) =><td>{v}</td>)
    console.log(Object.keys(firstArrayElement)) */
    const theadArray = Object.keys(firstArrayElement)
  return (
    <thead>
        <tr>
            {
              theadArray.map((v,i) => <th key={"th" + i}>{v}</th>)
            }
        </tr>
    </thead>
  )
}

const tbodyContent = (dataArray, dev_id, sensor_id, t_get_sensor_data_by_date, suffArray) => {
    //console.log(dataArray)
    return (
        //map all elements
            dataArray.map((e,k) => {
                return (<tr key={"e_" + k}
                    onClick = {()=>{
                        //console.log(e.date, dev_id, sensor_id)
                        t_get_sensor_data_by_date({dev_id: dev_id, sensor_id: sensor_id, date_i: e.date})
                    }}
                    >
                    {Object.entries(e).map((r,i)=>
                    <td key={'el_' + i} className={`${i === 0 ? "table_date_decor" : "text-secondary"}`}
                      
                    >
                       {/*  {r[1]} {suffArray[i]} */} 
                       {`${r[1] === null? '---': r[1] + suffArray[i]}`}
                    </td>)}
                </tr>)
            })

        )
            
}